import React, { useEffect, useRef } from "react";
import { useAnimations, useGLTF } from "@react-three/drei";
import { useState } from "react";
import { useDrawer, useOutline, useSection } from "../../../../common/hooks";
import { playBackward, playForward } from "../../../../utils/animations";
import { SECTIONS } from "../../../../constants/sections";
import {
  blackMaterial,
  blueMaterial,
  darkGrayMaterial,
  grayMaterial,
  greenTennisBall,
  redMaterial,
  screenMaterial,
  yellowMaterial,
} from "../../../../common/materials";

const model = "/models/hobbies/tv-stand.glb";

export default function TvStand(props) {
  const { openDrawer } = useDrawer();
  const group = useRef();
  const { nodes, materials, animations } = useGLTF(model);
  const { actions } = useAnimations(animations, group);
  const { addOutline, clearOutline } = useOutline();
  const { currentSection } = useSection();
  const [playedAnimations, setPlayedAnimations] = useState([]);

  const playAnimation = ({ actionKey, isForward }) => {
    if (currentSection.name === SECTIONS.HOBBIES) {
      if (isForward) {
        playForward(actions[actionKey]);
        setPlayedAnimations((prev) => [...prev, actionKey]);
      } else {
        playBackward(actions[actionKey]);
        setPlayedAnimations((prev) =>
          prev.filter((animation) => animation !== actionKey)
        );
      }
    }
  };

  const handleClick = (key) => {
    //TODO: Uncomment this code when the Drawer content is implemented
    // if (currentSection.name === SECTIONS.HOBBIES) {
    //   playAnimation({
    //     actionKey: key,
    //     isForward: true,
    //   });
    //   openDrawer({
    //     handleClose: () => playAnimation({ actionKey: key, isForward: false }),
    //   });
    // }
  };

  const onPointerEnter = ({ object }) => {
    //TODO: Uncomment this code when the Drawer content is implemented
    // if (currentSection.name === SECTIONS.HOBBIES) addOutline(object);
  };

  const onPointerLeave = ({ object }) => {
    //TODO: Uncomment this code when the Drawer content is implemented
    // if (currentSection.name === SECTIONS.HOBBIES) clearOutline();
  };

  useEffect(() => {
    if (currentSection.name !== SECTIONS.HOBBIES) {
      playedAnimations.forEach((animation) => {
        playBackward(actions[animation]);
      });
    }
  }, [currentSection]);

  return (
    <group ref={group} {...props} dispose={null}>
      <group
        onClick={() => {
          handleClick("controller");
        }}
        name="controller"
        position={[1.3, 0.91, 2.63]}
        rotation={[3.07, -0.35, 3.12]}
      >
        <mesh
          castShadow
          onPointerEnter={onPointerEnter}
          onPointerLeave={onPointerLeave}
          name="controller"
          geometry={nodes.Plane037.geometry}
          material={darkGrayMaterial}
        ></mesh>
        <mesh
          name="green button"
          geometry={nodes.Plane037_1.geometry}
          material={greenTennisBall}
        />
        <mesh
          name="red button"
          geometry={nodes.Plane037_2.geometry}
          material={redMaterial}
        />
        <mesh
          name="orange button"
          geometry={nodes.Plane037_3.geometry}
          material={yellowMaterial}
        />
        <mesh
          name="blue button"
          geometry={nodes.Plane037_4.geometry}
          material={blueMaterial}
        />
        <group
          name="controller_armature"
          position={[0, -0.03, 0]}
          rotation={[1.5, 0, -1.65]}
          scale={0.4}
        >
          <group name="Bone" />
        </group>
      </group>
      <group
        onClick={() => {
          handleClick("playstation");
        }}
        name="hobbies-playstation"
        position={[0.56, 0.29, 2.54]}
      >
        <mesh
          castShadow
          onPointerEnter={onPointerEnter}
          onPointerLeave={onPointerLeave}
          name="playstation"
          geometry={nodes.Cube022.geometry}
          material={darkGrayMaterial}
        ></mesh>

        <mesh
          name="ps2 text"
          geometry={nodes.Cube022_1.geometry}
          material={materials.ps2}
        />
        <group
          name="playstation_armature"
          position={[-0.02, -0.01, -0.02]}
          rotation={[0, 0, Math.PI / 2]}
        >
          <group name="Bone_1" />
        </group>
      </group>
      <group name="stand" position={[0.56, 0.26, 2.73]}>
        <mesh
          castShadow
          receiveShadow
          name="stand table"
          geometry={nodes.Cube019.geometry}
          material={materials["wood table"]}
        ></mesh>
        <mesh
          castShadow
          receiveShadow
          name="stand legs"
          geometry={nodes.Cube019_1.geometry}
          material={grayMaterial}
        ></mesh>
        <mesh
          castShadow
          receiveShadow
          name="stand inside"
          geometry={nodes.Cube019_2.geometry}
          material={materials.white}
        ></mesh>
      </group>

      <group name="tv" position={[0.55, 1.36, 2.83]}>
        <mesh
          castShadow
          name="tv"
          geometry={nodes.Cube012.geometry}
          material={blackMaterial}
        ></mesh>
        <mesh
          castShadow
          name="tv legs"
          geometry={nodes.Cube012_1.geometry}
          material={grayMaterial}
        ></mesh>
        <mesh
          name="tv screen"
          geometry={nodes.Cube012_2.geometry}
          material={screenMaterial}
        />
      </group>
    </group>
  );
}

useGLTF.preload(model);
